import { Component, type ErrorInfo, type ReactNode } from 'react';
import { debugLog } from './Logger';
import { captureComponentErrors } from './LoggerCrash';

interface ErrorHandlerProps {
	children?: ReactNode;
	onErrorComponent?: ReactNode;
	componentName: string;
}

interface ErrorHandlerState {
	hasError: boolean;
}

const TAG = 'ErrorHandler: ';

class ErrorHandler extends Component<ErrorHandlerProps, ErrorHandlerState> {
	constructor(props: ErrorHandlerProps) {
		super(props);
		this.state = { hasError: false };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		console.error(error, errorInfo, 'error');
		const { componentName } = this.props;
		debugLog(TAG, componentName);
		void captureComponentErrors({ error }, componentName).then(() => {
			debugLog(TAG, 'error captured');
		});
		this.setState({ hasError: true });
	}

	render(): ReactNode {
		const { hasError } = this.state;
		const { children, onErrorComponent } = this.props;

		if (onErrorComponent && hasError) {
			return <div>{onErrorComponent}</div>;
		}

		return hasError ? <div /> : children;
	}
}

export default ErrorHandler;
